import { AccountPixTypeEnum } from 'constants/enums/trucker';
import { IBank, IPix } from 'interfaces/profile.interface';
import { formatCPF } from 'utils/formatters';

export const getAccountTextToCopyToClipboard = (
  account: IBank,
  beneficiaryName: string,
  beneficiaryCPF: string,
  pix?: IPix
) => {
  const getBankName = () => {
    if (account.name) {
      return `${account.number} - ${account.name}`;
    }

    return account.number;
  };

  const getAccountNumber = () => account.account.number.replace(/(\w)$/, '-$1');

  const getPix = () => {
    if (!pix?.key || !AccountPixTypeEnum[pix?.type] || pix?.status !== 'active') return '';

    return `\n  PIX\n   Tipo de chave: ${AccountPixTypeEnum[pix?.type]}\n   Chave PIX: ${pix?.key}`;
  };

  const getAccountText = () => `Esses são os dados da conta digital Fretebras do motorista:
  Banco: ${getBankName()}
  Agência: ${account.account.branchNumber}
  Conta corrente: ${getAccountNumber()}
  Nome: ${beneficiaryName}
  CPF: ${formatCPF(beneficiaryCPF)}${getPix()}`;

  return getAccountText();
};
